import { CacheAdapter } from '@shared/infra'
import { useEffect } from 'react'
import { clarity } from 'react-microsoft-clarity'

import { env } from '@/env'

export function HeadScripts() {
  const userData = CacheAdapter.get('userData')
  const isInternalEnv = env.VITE_ENV === 'internal'
  const projectId = env.VITE_MICROSOFT_CLARITY_KEY

  useEffect(() => {
    if (!isInternalEnv || !projectId) return
    const attrs = userData?.attributes
    if (!attrs) return

    try {
      clarity.init(projectId)
      clarity.consent(true)

      if (attrs.email)
        clarity.identify('USER_EMAIL', { userProperty: attrs.email })
      if (attrs.name)
        clarity.identify('USER_NAME', { userProperty: attrs.name })
      if (attrs.phone_number)
        clarity.identify('USER_PHONE', { userProperty: attrs.phone_number })
    } catch (error) {
      console.warn('Failed to initialize Microsoft Clarity:', error)
    }
  }, [isInternalEnv, projectId, userData])

  useEffect(() => {
    if (env.VITE_ENV === 'production') {
      const zendeskScript = document.createElement('script')
      zendeskScript.id = 'ze-snippet'
      zendeskScript.src = `https://static.zdassets.com/ekr/snippet.js?key=${env.VITE_ZENDESK_KEY}`
      document.body.appendChild(zendeskScript)
    }
  }, [])

  return null
}
